import { PlusIcon } from "@phosphor-icons/react/Plus";
import { Button } from "@freightsimple/ui-core/Controls/Button";
import { Heading } from "@freightsimple/ui-core/Typography/Heading";
import { Link } from "@freightsimple/ui-core/Typography/Link";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import { useNavigate } from "react-router-dom";
import FullWidthLayout from "@/Shared/Layout/CustomComponents/FullWidthLayout";
import { BankAccountsAddButton } from "./Buttons/BankAccountsAddButton";
import BankAccountsSection from "./CustomComponents/BankAccountsSection";
import { useBankAccounts } from "./Hooks/useBankAccounts";

function BankAccountsScreen() {
  const navigate = useNavigate();
  const {
    bankAccounts,
    creditCards,
    initialLoading,
    retryFailedLoad,
    allowRemoveAccountButton,
    noBankAccounts,
    addNewBankAccount,
    removeBankAccount,
    verifyBankAccount,
    setDefaultBankAccount,
    dialogs,
  } = useBankAccounts();

  return (
    <>
      {/* Outside the layout so the add flow also works from the empty state. */}
      {dialogs}
      <FullWidthLayout
        header="Bank Accounts"
        microcopy={
          <>
            You can manage your bank accounts here. Don&apos;t have access to
            the company bank account?{" "}
            <Link onClick={() => navigate("/manage-users")}>
              Click here to invite someone else to add it
            </Link>
            .
          </>
        }
        rightContent={
          <Button primary icon={PlusIcon} onClick={addNewBankAccount}>
            Add New Bank Account
          </Button>
        }
        loading={initialLoading}
        onRetryFailedLoad={retryFailedLoad}
        showEmptyState={noBankAccounts}
        emptyState={
          <Stack gap={6} align="center">
            <Stack gap={2} align="center">
              <Heading level={1}>
                You don&apos;t have any bank accounts saved yet
              </Heading>
              <T color="secondary">
                Adding a bank account to FreightSimple makes it convenient and
                easy to pay for your freight.
              </T>
            </Stack>
            <Stack gap={4} align="center">
              <BankAccountsAddButton onClick={addNewBankAccount} />
              <Button size="link" onClick={() => navigate("/manage-users")}>
                Don&apos;t have access to the company bank account details?
                Click here to invite someone who does
              </Button>
            </Stack>
          </Stack>
        }
        content={
          <BankAccountsSection
            creditCards={creditCards}
            bankAccounts={bankAccounts}
            setDefaultBankAccount={setDefaultBankAccount}
            removeBankAccount={removeBankAccount}
            allowRemoveAccountButton={allowRemoveAccountButton}
            verifyBankAccount={verifyBankAccount}
          />
        }
      />
    </>
  );
}

export default BankAccountsScreen;
